// Loaders
import defaultLoaderDark from '../assets/img/loaders/loader.gif';
import defaultLoaderLight from '../assets/img/loaders/loader-light.gif';
import bufferLoader from '../assets/img/loaders/buffer.gif';
// Background
import materialBgDark from '../assets/img/background/material-dark.jpg';
import materialBgLight from '../assets/img/background/material-light.jpg';
import glitchLight1 from '../assets/img/background/glitch-light1.webp';
import glitchLight2 from '../assets/img/background/glitch-light2.webp';
import kiss from '../assets/img/background/kiss.png';
import astronaut from '../assets/img/background/astronaut.png';

import world from '../assets/img/background/world-bg.png';
import web from '../assets/img/background/web-bg.png';
// Logo
import logoLight from '../assets/img/logo/vox-logo-light.png';
import logoDark from '../assets/img/logo/vox-logo-dark.png';
// Wallpapers
import wallpaper1 from '../assets/img/wallpapers/wallpaper1.jpg';
import wallpaper2 from '../assets/img/wallpapers/wallpaper2.jpg';
import wallpaper3 from '../assets/img/wallpapers/wallpaper3.jpg';
import wallpaper4 from '../assets/img/wallpapers/wallpaper4.jpg';
import wallpaper5 from '../assets/img/wallpapers/wallpaper5.jpg';
import wallpaper6 from '../assets/img/wallpapers/wallpaper6.jpg';
// Misc
import doubleLine from '../assets/img/misc/double-line.png';
import unknownUser from '../assets/img/misc/unknown-user.png';
import playerBg from '../assets/img/misc/player-bg.gif';
import imgPlaceholder from '../assets/img/misc/img-placeholder.png';
import playlistImgPlaceholder from '../assets/img/misc/vox-music.png';

export const localImgService = {
  // Loaders
  defaultLoaderDark,
  defaultLoaderLight,
  bufferLoader,

  // Background
  materialBgDark,
  materialBgLight,
  glitchLight1,
  glitchLight2,
  world,
  web,
  kiss,
  astronaut,

  // Logo
  logoLight,
  logoDark,

  // Wallpapers
  wallpapers: [
    wallpaper1,
    wallpaper2,
    wallpaper3,
    wallpaper4,
    wallpaper5,
    wallpaper6,
  ],

  // Misc
  doubleLine,
  unknownUser,
  playerBg,
  imgPlaceholder,
  playlistImgPlaceholder,
};
